<template>
    <v-app id="app" >
        <Menu />
        <router-view></router-view>        
    </v-app>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import Menu from "@/components/Menu.vue"

export default {
    name: "App",

    data () {
        return {  }
    },

    components: { Menu },

    mounted: function () {
        this.fetchBuildings()
        
        // Hide / Show Toolbar
        if (this.$route.query.highlightRooms || this.$route.params.bldg || this.$route.params.room || this.$route.query.buildings || this.$route.query.labels) { 
            this.setShowToolbar(false) 
        } else { 
            this.setShowToolbar(true) 
        }  

        // ELEVATOR
        let bool = this.$route.query.elevator
        bool && this.setShowElevator(bool)

        // Title for tooltip/infotemplate label/popup
        //console.log("hoverLabelTitle", this.$route.query.hoverLabelTitle)
        if (this.$route.query.hoverLabelTitle) {
            this.setHoverLabelTitle(this.$route.query.hoverLabelTitle)
        }

        // Basemaps
        if (this.$route.query.basemap) {

        }




    },

    watch: {
        async mapReady (val) { 
            ////console.log("Map Ready")

            // HIGHLIGHT ROOMS V2
            if (this.$route.query.highlightRoomsV2) { 
                this.processUrlParametersHighlightingV2(this.$route.query.highlightRoomsV2)
            }

            // HIGHLIGHT ROOMS
            if (this.$route.query.highlightRooms) { 
                this.processUrlParametersHighlighting(this.$route.query.highlightRooms)
            } 

            // LINE DETAIL
            if (this.$route.query.detail == 'true') { this.setShowDetail(true); this.updateLayerVisibility(1) }

            // POINTS
            if (this.$route.query.points) {
                console.log("Points Payload: ", this.$route.query.points)
                let pointsJson = JSON.parse(this.$route.query.points)
                await this.addPoints(pointsJson)
                this.setShowMap(true)
                this.setShowToolbar(false)
            } 

            // FLOOR
            let floor = this.$route.query.floor
            floor && this.updateLayerVisibility(floor)

            // BUILDING HIGHLIGHTING AND LABELING
            if (this.$route.query.buildings) {                
                this.setShowElevator(true) //Enable Elevator Control
                let buildingsJson = JSON.parse(this.$route.query.buildings)
                await this.multiHighlightBuilding(buildingsJson)
                this.setShowMap(true)
                this.setShowToolbar(false)
            }
             
            // ROOM LABELING
            // labels: {"bldg":"300A", "rooms":["A306","A316","A313","A339","A319","A303","A300S"],"labels":["Headquarters", "Chocolate Chip\nCookies","Milk","Snack Station","BBQ Pit","Petting Zoo","Barista"]}
            if (this.$route.query.labels) {
                //console.log(this.$route.query.labels)
                let labelJson = JSON.parse(this.$route.query.labels)
                this.suppressDSMLLabels(true) 

                // Convert to array if necessary.  Allows backward compatibility.  Original version was single labels object, not an array
                if (!Array.isArray(labelJson)) { let tempArray = []; tempArray.push(labelJson); labelJson = tempArray;}
                
                // Get floor based on first room, and switch to it
                //console.log(this.$route)
                console.log("Bldg: ", labelJson[0].bldg )
                let floor = await this.getFloorByFacID(labelJson[0].bldg + "-" + labelJson[0].rooms[0])
                console.log(floor)
                this.updateLayerVisibility(floor)
                this.setCurrentFloor(floor) 

                labelJson.forEach(async(labelSet) => {
                    // Highlight Building
                    await this.highlightBuilding({ 'bldgAlpha': labelSet.bldg })

                    // Add RI so we have graphics to attach labels to
                    await this.addRoomInteractivity(labelSet.bldg) 

                    // Apply labels
                    await this.applyLabels(labelSet) 
                    this.setShowMap(true)
                    this.setShowToolbar(false)
                })

                
            }  

            


            //Set Zoom
            if (this.$route.query.zoomLevel) {
                console.log("User Selected Zoom: ", this.$route.query.zoomLevel)  
                this.setZoomLevel(this.$route.query.zoomLevel)
            }
        },
    },

    computed: {
        ...mapState({   showToolbar:            state => state.ui.showToolbar,
                        mapReady:               state => state.ui.mapReady,
                        interiorMappingDMSL:    state => state.mapFunction.interiorMappingDMSL,
                    }),
    },

    methods: {
        ...mapActions([ 'fetchBuildings', 'highlightRoomsByKey', 'centerOverRooms', 'getFloorByFacID', 'getRoomByFacIDV2', 'labelBuildings', 'addPoints', 'addRoomInteractivity', 'applyLabels', 'updateLayerVisibility', 'highlightBuilding', 'multiHighlightBuilding', 'setCurrentFloor']),   
        ...mapMutations(['setShowToolbar', 'setShowDetail', 'setShowMap', 'setHoverLabelTitle', 'suppressDSMLLabels', 'setZoomLevel', 'setShowElevator' ]),
        
        async processUrlParametersHighlightingV2(urlParameter) {
            //Break into groups
            let roomGroups = urlParameter.split("~")
            ////console.log("roomGroups: ", roomGroups)
            let allRooms = []

            // Process highlightRoom package
            // <color><label><roomarray>:<color><label><roomarray>
            // <63,81,181,0.5><"Label1", "Label2"><300A-A104,300A-A106>:<163,81,81,0.5><"Label1", "Label2"><300A-A108,300A-A108B>

            //Find Floor using first room
            let group = roomGroups[0]
            let firstRoom = group.substring(group.lastIndexOf("<")+1, group.lastIndexOf(">")) 
            firstRoom = firstRoom.split(',')         
            firstRoom = firstRoom[0]
            console.log("FirstRoom: ", firstRoom)

            let room = await this.getRoomByFacIDV2({ 'facIdNum' : firstRoom })
            console.log("Using Floor: ", room.floor)
            if (this.currentFloor != room.floor) { this.updateLayerVisibility(room.floor) } // Change Floors
            

            roomGroups.forEach((group) => {
                
                // Get Color
                let colorstring = group.substring(1,group.indexOf("><"))

                // replace brackets <> with [].  This just makes JSON.Parse able to work. 
                colorstring = colorstring.replace(/\</g, "[")
                colorstring = colorstring.replace(/\>/g, "]")

                console.log(colorstring)

                let colorArray = JSON.parse("[" + colorstring + "]"); // parses to three element array RGB
                colorArray[3] = 0.5 // Add Transparency as fourth element in this array
                
                // Parse out the custom hover labels
                // Get the substring between ><+2 and the next >
                let hoverLabel = group.substring(group.indexOf("><")+2, group.indexOf(">",group.indexOf("><")+2) )
                
                hoverLabel = hoverLabel.split(',')  // Makes a proper array
                //console.log("hoverLabels", hoverLabel) 

                // Get and Process Room Array
                let roomArray = group.substr(group.lastIndexOf("<"))  

                // Format Room key Array for Where Clause
                roomArray = roomArray.replace(/\</g, "'")
                roomArray = roomArray.replace(/,/g, "','")
                roomArray = roomArray.replace(/\>/g, "'")

                //color = [63,81,181,.5]
                let payload = { roomKeys: roomArray, color: colorArray, floor: room.floor, hoverLabel: hoverLabel, version: 2 } 
                this.highlightRoomsByKey(payload)
                allRooms = allRooms + roomArray + ','

            })    

            // Center over the entire set of rooms  
            allRooms = allRooms.substring(0,allRooms.length-1)      
            this.centerOverRooms({ 'roomArray': allRooms, 'floor': room.floor, 'version': 2 })

            
        }, 

        async processUrlParametersHighlighting(urlParameter) {
            //Break into groups
            let roomGroups = urlParameter.split(":")
            ////console.log("roomGroups: ", roomGroups)
            let allRooms = []

            // Process highlightRoom package
            // [color][roomarray]:[color][roomarray]
            // [63,81,181,0.5][300A-A104,300A-A106]:[163,81,81,0.5][300A-A108,300A-A108B]

            //Find Floor using first room
            let group = roomGroups[0]
            let firstRoom = group.substring(group.lastIndexOf("[")+1, group.lastIndexOf("]")) 
            firstRoom = firstRoom.split(',')         
            firstRoom = firstRoom[0]
            ////console.log("FirstRoom: ", firstRoom)

            let floor = await this.getFloorByFacID(firstRoom)
            ////console.log("Using Floor: ", floor)

            

            roomGroups.forEach((group) => {
                
                // Get Color
                let colorstring = group.substring(1,group.indexOf("]["))
                let colorArray = JSON.parse("[" + colorstring + "]"); // parses to three element array RGB
                colorArray[3] = 0.5 // Add Transparency as fourth element in this array
                
                // Parse out the custom hover labels
                // Get the substring between ][+2 and the next ]
                let hoverLabel = group.substring(group.indexOf("][")+2, group.indexOf("]",group.indexOf("][")+2) )
                
                hoverLabel = hoverLabel.split(',')  // Makes a proper array

                // Get and Process Room Array
                let roomArray = group.substr(group.lastIndexOf("["))       

                // Format Room key Array for Where Clause
                roomArray = roomArray.replace(/\[/g, "'")
                roomArray = roomArray.replace(/,/g, "','")
                roomArray = roomArray.replace(/\]/g, "'")
                roomArray = roomArray.replace(/-/g, "+")

                //color = [63,81,181,.5]
                let payload = { roomKeys: roomArray, color: colorArray, floor: floor, hoverLabel: hoverLabel } 
                this.highlightRoomsByKey(payload)
                allRooms = allRooms + roomArray + ','

            })    

            // Center over the entire set of rooms  
            allRooms = allRooms.substring(0,allRooms.length-1)      
            this.centerOverRooms({ 'roomArray': allRooms, 'floor': floor })

            
        }         
    },
}

</script>

<style>
#app {
  margin-top: 0px;
  height: 100%;
  overflow-y: hidden !important;
  overflow-x: hidden;
/*  border-width: 2px;
  border-style: solid;*/
}

html {
  font-size:16px !important;
}

.esriPopup .action.zoomTo { display: none; }

</style>